/* eslint-disable @typescript-eslint/no-explicit-any */
import { IonSpinner } from '@ionic/react';
import { useEffect, useRef } from 'react';
// import {
//   DefaultStreamChatGenerics,
//   TypingIndicatorProps,
//   useChannelStateContext,
//   useChatContext,
//   useTypingContext,
// } from 'stream-chat-react';

import { BaseProps } from '@/types/props';

import LLMChatBubble from './LLMChatBubble';

interface Props extends BaseProps {
  threadList?: boolean;
}

const TypingIndicator: React.FC<Props> = ({ threadList, className, style }) => {
  const ref = useRef<HTMLDivElement>(null);
  // @ts-ignore - stream-chat not available
  const channelConfig: any = null;
  const thread: any = null;
  // useChannelStateContext<DefaultStreamChatGenerics>('TypingIndicator');
  // @ts-ignore - stream-chat not available
  const client: any = { user: { id: '' } }; // useChatContext<DefaultStreamChatGenerics>('TypingIndicator');
  const typing: any = {}; // useTypingContext<DefaultStreamChatGenerics>('TypingIndicator');

  const typingInChannel = !threadList
    ? Object.values(typing).filter(
      (item: any) => item?.user?.id !== client.user?.id && !item?.parent_id
    )
    : [];

  const typingInThread = threadList
    ? Object.values(typing).filter(
      (item: any) => item?.user?.id !== client.user?.id && item?.parent_id === thread?.id
    )
    : [];

  const isTypingActive =
    (threadList && typingInThread.length > 0) || (!threadList && typingInChannel.length > 0);

  useEffect(() => {
    if (channelConfig?.typing_events === false) return;

    if (!isTypingActive) return;

    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [isTypingActive, channelConfig?.typing_events]);

  if (channelConfig?.typing_events === false) {
    return null;
  }

  if (!isTypingActive) return null;

  return (
    <LLMChatBubble className={className} style={style} ref={ref}>
      <IonSpinner name="dots" />
    </LLMChatBubble>
  );
};

export default TypingIndicator;
